import { UUID, Skill, Ability, dayjs } from '@umanforge/common';
import { CalendarEvent } from 'interfaces/calendar.interface';

export interface Line {
  id: UUID;
  name: string; //title
  events: CalendarEvent[];

  object?: {
    id: string,
    color: string,
    skills: Skill[],
    abilities: Ability[],
    //users: []
  };
}

export interface Column {
  value: number;
  name: string;
  rawValue: string;
  subColumns?: string[]
}

export interface DragCase {
  line: Line,
  hour: number;
}

export class ChronogramService {

  static sortEventsDay = ( events: CalendarEvent[] ): CalendarEvent[] => {
    if ( !events || events.length <= 1 ) {
      return events;
    }

    // sort events by start hour and minutes
    events.sort( ( a, b ) => {
      return dayjs( a.task?.dateStart ).isBefore( dayjs( b.task?.dateStart ) ) ? -1 : 0;
    } );

    const lines: Array<{ value: number; events: CalendarEvent[] }> = [];
    lines.push( { value: parseInt( dayjs( events[ 0 ].task?.dateStart ).format( 'HHmm' ) ), events: [] } );

    for ( const event of events ) {
      const startHour = parseInt( dayjs( event.task?.dateStart ).format( 'HHmm' ) );
      const endHour = parseInt( dayjs( event.task?.dateEnd ).format( 'HHmm' ) );

      // apply the sort algo
      let check = false;
      for ( const line of lines ) {
        if ( line.value <= startHour ) {
          line.value = endHour;
          line.events.push( event );
          check = true;
          break;
        }
      }
      if ( !check ) {
        lines.push( { value: endHour, events: [ event ] } );
      }
    }

    // make the new tab with the sorted lines
    // and comapre index to determine stacked or not
    const resEvents: CalendarEvent[] = [];
    for ( let index = 0; index < lines.length; index++ ) {
      const stacked = index !== 0;
      for ( const event of lines[ index ].events ) {
        event.stacked = stacked;
        resEvents.push( event );
      }
    }

    return resEvents;
  };

  static sortEventsWeek = ( events: CalendarEvent[], startDay: dayjs.Dayjs ): CalendarEvent[] => {
    if ( !events || events.length <= 1 ) { return events; }

    // sort events by start hour and minutes
    events.sort( ( a, b ) => {
      return dayjs( a.task?.dateStart ).isBefore( dayjs( b.task?.dateStart ) ) ? -1 : 0;
    } );

    const perDays: Array<{ day: dayjs.Dayjs; events: CalendarEvent[] }> = [ {
      day: startDay.startOf( 'day' ),
      events: []
    } ];


    // sort per day
    for ( const event of events ) {
      let day = dayjs( event.task?.dateStart );
      if ( day.startOf( 'day' ).isBefore( startDay ) ) {
        day = startDay.clone();
      }

      let check = false;
      for ( const col of perDays ) {
        if ( col.day.format( 'MDD' ) == day.format( 'MDD' ) ) {
          col.events.push( event );
          check = true;
          break;
        }
      }
      if ( !check ) {
        perDays.push( { day: day, events: [ event ] } );
      }
    }

    const res: CalendarEvent[] = [];
    while ( perDays.some( pd => { return pd.events.length > 0; } ) ) {
      for ( let index = 0; index < perDays.length; index++ ) {
        const event = perDays[ index ].events.pop();
        if ( event ) {
          res.push( event );
          const days = dayjs( event.task?.dateEnd ).diff( perDays[ index ].day, 'day' );
          if ( days >= 1 ) {
            index += days;
          }
        }
      }
    }
    return res;
  };
}
